module.exports = __webpack_public_path__ + "static/media/item_17_1_comp.ff7715a0.png";